import { useMutation } from '@tanstack/react-query';
import { accountApi } from '../services/accountApi';
import { ChangePasswordRequest } from '@troia-v3/types';

/**
 * Hook to update current user password
 */
export const useUpdatePassword = () => {
  return useMutation({
    mutationFn: (data: ChangePasswordRequest) => accountApi.updatePassword(data),
  });
};
